import React from "react";
import Icon1 from "../../images/R2.png";
import Icon2 from "../../images/Peacer.png";
// import Icon3 from "../../images/Trisian.png";
import Icon4 from "../../images/Healthrix.png";

import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
} from "./ServicesElements";

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>TEAM</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Filcona</ServicesH2>
          <ServicesP>Artist</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Jerry</ServicesH2>
          <ServicesP>Developer</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon4} />
          <ServicesH2>ADAM</ServicesH2>
          <ServicesP>Developer</ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
